import { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../../../common/CmnContext';
import { PracticeReseveContext } from '../../../PracticeReseveContext';
import PracticeReserveSelectInstructorModalHead from './head/PracticeReserveSelectInstructorModalHead';
import PracticeReserveSelectInstructorModalSelected from './selected/PracticeReserveSelectInstructorModalSelected';
import PracticeReserveSelectInstructorModalItem from './item/PracticeReserveSelectInstructorModalItem';


function PracticeReserveSelectInstructorModal(props: any) {

  const isPc = useContext(cmnContext).isPc;
  const { instructors } = useContext(PracticeReseveContext);

  const selectInst = props.selectInst;
  const setIsDispModal = props.setIsDispModal;
  // リクエストモーダル
  const setIsDispRequest = props.setIsDispRequest;

  const jaRandomInstructor = props.jaRandomInstructor;
  // 講師情報から画像取得
  const getInstImg = props.getInstImg;
  // 講師情報(日本語可/出身地)
  const getInstInfo = props.getInstInfo;

  const listRef = useRef<HTMLDivElement>(null);
  const [listWidth, setListWidth] = useState<number>(0);

  useEffect(() => {
    if (listRef.current) {
      setListWidth(listRef.current.offsetWidth);
      // 画面リサイズにも対応したい場合
      const handleResize = () => setListWidth(listRef.current!.offsetWidth);
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);


  const onClickRequest = () => {
    setIsDispModal(false);
    setIsDispRequest(true);
  }


  return (
    <div style={{backgroundColor: '#fff'}}>

      {/* header */}
      <PracticeReserveSelectInstructorModalHead
        setIsDispModal={setIsDispModal}
      />

      <hr style={{margin: '5px 0'}} />

      {selectInst ?
        <>
          {/* 選択中 */}
          <PracticeReserveSelectInstructorModalSelected
            selectInst={selectInst}
            jaRandomInstructor={jaRandomInstructor}
          />
        </>
      :
        <>
          {/* リクエスト */}
          <div className="text-right" style={{margin: '0 10px 5px 0'}}>
            <div
              className="btn btn-info"
              style={{padding: '5px 10px', fontSize: '80%'}}
              onClick={onClickRequest}
            >⇒ 希望講師がいない場合</div>
          </div>
        </>
      }

      {/* 一覧 */}
      <div
        ref={listRef}
        className='row'
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          flexGrow: 1,
          overflowY: 'auto',
          paddingRight: '5px',
          margin: 0,
        }}
      >
        {instructors && instructors.map((inst: any, index: number) => {
          const rowIndex = isPc ? Math.floor(index / 2) : index;
          const bgColor = rowIndex % 2 === 0 ? '#f8f8f8' : '#ffffff'; // 交互に色変更
          return (
            <div
              key={inst.inst_id}
              className="col-xs-12 col-sm-6"
              style={{ backgroundColor: bgColor }}
            >
              <PracticeReserveSelectInstructorModalItem
                inst={inst}
                setIsDispModal={setIsDispModal}
                listWidth={listWidth}
                jaRandomInstructor={jaRandomInstructor}
                getInstImg={getInstImg}
                getInstInfo={getInstInfo}
              />
            </div>
          );
        })}
      </div>

    </div>
  );
}
  
export default PracticeReserveSelectInstructorModal;